import * as moment from 'moment';
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

export class CNLaboResult {
    public code: string;
    public name: string;
    public norm: string;
    public unit: string;
    public result: string;
    public anomaly: boolean;
    public show: boolean;
}

@RegisterItem()
export class CNLabo extends CNItem {

    public results: CNLaboResult[] = [];
    public anomalies: CNLaboResult[] = [];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'stvaast_labo';
    }

    get date(): Date {
        if (this.getProperty('DateDemande')) {
            return moment(this.getProperty('DateDemande'), 'DD/MM/YYYY').toDate();
        }
        return this.createddate;
    }

    public clone(): any {
        return new CNLabo();
    }

    public fromJson(json, emitLoaded = true) {
        super.fromJson(json, emitLoaded);
        if (typeof(json.results) !== 'undefined') {
            this.results = json.results;
        }
        if (typeof(json.anomalies) !== 'undefined') {
            this.anomalies = json.anomalies;
        }
    }
}
